import { DownloadOutlined } from '@mui/icons-material';
import classes from './TermsConditions.module.scss';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import Navbar from 'components/navbar/Navbar';

const TermsAndConditions = () => {
    return (
        <div className={classes.container}>
            <header className={classes.header}>
                <div className={classes.title}>
                    <img src="/assets/images/logo_sis_white.png" alt="logo sis" />
                    <Navbar />
                </div>
                <h1 className={classes.subtitle}>Termini & Condizioni</h1>
            </header>
            <main className={classes.main}>
                <div className={classes.content}>
                    <div className={classes.bodyHeader}>
                        <div className={classes.date}>
                            <CalendarMonthOutlinedIcon />
                            <span>
                                Ultimo aggiornamento:
                                <b> 20 Giugno 2025</b>
                            </span>
                        </div>
                        <a href="/assets/pdf/condizioni_generali.pdf" download="Condizioni Generali.pdf">
                            <DownloadOutlined />
                            Scarica versione .pdf
                        </a>
                    </div>
                    <div className={classes.body}>
                        <div>
                            <h1>
                                Termini e condizioni generali di accesso ed utilizzazione del Servizio “MUVIN” (lingua Italiana)
                            </h1>
                            <p>
                                I presenti termini e condizioni generali di contratto costituiscono un contratto (il “
                                <b>Contratto</b>”) tra l’utente del servizio MUVIN e S.I.S. Segnaletica Industriale Stradale
                                S.r.l., con sede in Via Torquato Tasso n. 12, 06073 Corciano (PG) (“<b>SIS</b>”) e stabiliscono le
                                condizioni di erogazione e fruizione del servizio MUVIN avente ad oggetto il pagamento tramite
                                strumenti di telefonia mobile di servizi di parcheggio pubblico e di altri servizi accessori
                                offerti da SIS (il “<b>Servizio</b>”).
                            </p>
                            <p>
                                Le condizioni del Contratto sono consultabili in ogni momento presso il sito internet di SIS
                                all’indirizzo{' '}
                                <a href="https://app.muvin.it/terms-and-conditions">https://app.muvin.it/terms-and-conditions</a>
                            </p>
                        </div>
                        <div>
                            <h1>Articolo 1 – Oggetto del Contratto</h1>
                            <p>SIS agisce alternativamente in qualità di:</p>
                            <ol type="a">
                                <li>
                                    <p>soggetto gestore dei servizi di sosta in aree, strutture e zone; ovvero</p>
                                </li>
                                <li>
                                    <p>
                                        da intermediario tra il soggetto gestore dei servizi di sosta in aree, strutture e zone
                                        convenzionato con SIS e l’utilizzatore del Servizio (d’ora in avanti SIS e il predetto
                                        soggetto gestore detti anche “<b>Concessionari</b>”)
                                    </p>
                                </li>
                            </ol>
                            <p>
                                L’utilizzatore del Servizio può corrispondere ai Concessionari la tariffa per usufruire del
                                servizio a pagamento utilizzando una carta bancaria (di credito o di debito) a mezzo di telefono
                                cellulare o altro dispositivo mobile con accesso a Internet.
                            </p>
                            <p>
                                L’attivazione e l’utilizzazione del Servizio da parte del Cliente implicano la piena ed integrale
                                accettazione di tutte le condizioni di cui al presente Contratto.
                            </p>
                        </div>
                        <div>
                            <h1>Articolo 2 – Condizioni di accesso al Servizio</h1>
                            <p>
                                <b>2.1</b> L’accesso e l’uso del Servizio potrà avvenire attraverso una applicazione digitale
                                denominata “<i>MUVIN App</i>” (d’ora in avanti detta “<b>Applicazione</b>”) che può essere
                                scaricata su ogni dispositivo portatile compatibile con i sistemi iOS e Android, la cui
                                utilizzazione potrà essere soggetta al pagamento di una separata tariffa in alcune aree
                                geografiche come espressamente e preventivamente segnalato dall’Applicazione stessa.
                            </p>
                            <p>
                                Possono accedere ed essere utilizzatori del Servizio le persone fisiche, sia che agiscano per
                                scopi estranei all’attività imprenditoriale, commerciale, artigianale o professionale svolta dalle
                                stesse, sia che agiscano ai fini e nell’ambito delle predette attività, che siano in possesso, per
                                l’intera durata del Contratto, dei seguenti requisiti (d’ora in avanti il “<b>Cliente</b>”)
                            </p>
                            <ol type="a">
                                <li>
                                    <p>abbiano un’età minima pari a 18 anni;</p>
                                </li>
                                <li>
                                    <p>
                                        dispongano di un accesso alla rete Internet a mezzo di un dispositivo portatile (telefono
                                        cellulare o <i>tablet</i>) che utilizzi un sistema operativo compatibile che utilizzi iOS
                                        1 o una versione successiva o Android 14 o una versione successiva;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        accettino di creare un profilo utente (il “<b>Profilo Utente</b>”) nell’Applicazione
                                        attraverso la indicazione dei seguenti dati che li riguardano:
                                    </p>
                                    <ol type="i">
                                        <li>
                                            <p>nome e cognome;</p>
                                        </li>
                                        <li>
                                            <p>numero di telefono;</p>
                                        </li>
                                        <li>
                                            <p>targa del veicolo con il quale intendono usufruire del Servizio;</p>
                                        </li>
                                    </ol>
                                    <p>
                                        o, in alternativa, accedano all’Applicazione direttamente tramite le proprie utenze Apple
                                        o Google (il “<b>Single Sign-On</b>”) e indichino il numero di targa di cui al punto (iii)
                                        che precede.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        dispongano delle carte di credito o di debito accettate di volta in volta dal Fornitore
                                        dei Servizi di Pagamento (come definito al successivo art.5.2) indicate nelle condizioni
                                        di erogazione del servizio dallo stesso predisposte e consultabili presso{' '}
                                        <a href="https://www.nexi.it">https://www.nexi.it</a> ed aderiscano a dette condizioni;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {' '}
                                        intendano avvalersi del Servizio ai fini del pagamento della sosta del proprio veicolo
                                        solo in aree di sosta, strutture e zone gestite da Concessionari, elencate di volta in
                                        volta nell’Applicazione, inserendo all’interno dell’Applicazione la targa del veicolo di
                                        volta in volta utilizzato dal Cliente;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        accettino i termini e le condizioni di cui al presente Contratto e prendano visione della
                                        Privacy Policy dell’Applicazione.
                                    </p>
                                </li>
                            </ol>
                            <p>
                                <b>2.2</b> A maggior chiarimento di quanto stabilito nel precedente art.2.1, il Cliente da atto di
                                ben comprendere ed accetta espressamente che, nell’ipotesi in cui il Cliente non dovesse accettare
                                tutte le condizioni di fornitura di cui al precedente art.2.1, ovvero non fosse più in grado di
                                aderire alle stesse nel corso della fornitura del Servizio, il Servizio non potrà essere erogato
                                da SIS.
                            </p>
                        </div>
                        <div>
                            <h1>
                                Articolo 3 – Durata del Contratto di fornitura del Servizio – Diritto di recesso del Cliente -
                                Diritto di recesso di SIS{' '}
                            </h1>
                            <p>
                                <b>3.1</b> Il Contratto entrerà in vigore al momento della espressa accettazione da parte del
                                Cliente del presente Contratto e della conferma di presa visione della Privacy Policy
                            </p>
                            <p>
                                Il Cliente, con l’accettazione del presente Contratto da atto altresì che riceverà copia dello
                                stesso a mezzo di SMS presso il numero di telefono indicato dal Cliente, o, in caso di accesso
                                tramite Single Sign-On, all’indirizzo e-mail legato all’utenza Apple o Google utilizzata per
                                accedere, nonché nella sezione “<i>Informazioni legali</i>” dell’Applicazione.
                            </p>
                            <p>
                                <b>3.2</b> Ai sensi dell’art. 52 del Decreto Legislativo 206/2005 (il “<b>Codice del Consumo</b>
                                ”), è in ogni caso fatto salvo il diritto del Cliente di recedere dal Contratto entro 14
                                (quattordici) giorni dalla 3 sottoscrizione dello stesso come sopra indicata (il “
                                <b>Periodo di Legge</b>”), senza dover fornire alcuna motivazione e senza dover sostenere costi
                                aggiuntivi, compilando ed inviando a SIS la apposita comunicazione di recesso - che sarà
                                scaricabile dal sito{' '}
                                <a href="https://app.muvin.it/privacy-policy">
                                    <i>https://app.muvin.it/privacy-policy</i>
                                </a>{' '}
                                - via posta elettronica al seguente indirizzo{' '}
                                <a href="mailto:recesso@muvin.it">
                                    <i>recesso@muvin.it</i>
                                </a>
                                , salvo in ogni caso il pagamento del Corrispettivo (come infra definito) relativo alla eventuale
                                fruizione del Servizio fino alla data di recesso.
                            </p>
                            <p>
                                Al Cliente sarà comunicata l’avvenuta ricezione della comunicazione di recesso qualora la stessa
                                sia stata validamente trasmessa entro il termine indicato.
                            </p>
                            <p>
                                <b>3.3</b> Successivamente alla scadenza del Periodo di Legge, il Cliente potrà recedere in
                                qualsiasi momento dal Contratto con l’invio al recapito indicato in epigrafe di apposita
                                comunicazione a SIS a mezzo di lettera raccomandata con avviso di ricevimento. Il recesso così
                                esercitato avrà efficacia al momento del ricevimento della predetta comunicazione da parte di SIS,
                                salvo in ogni caso il pagamento del Corrispettivo relativo alla eventuale fruizione del Servizio
                                fino alla data di recesso.
                            </p>
                            <p>
                                <b>3.4</b> SIS potrà recedere in qualsiasi momento dal Contratto con l’invio di apposita
                                comunicazione al Cliente a mezzo di e-mail oppure attraverso SMS al recapito telefonico indicato
                                dal Cliente, con un preavviso non inferiore a 90 (novanta) giorni.
                            </p>
                            <p>
                                Il recesso così esercitato da SIS avrà efficacia al momento della scadenza del termine di
                                preavviso indicato, salvo in ogni caso il pagamento del Corrispettivo relativo alla eventuale
                                fruizione del Servizio ad opera del Cliente fino alla data di recesso.
                            </p>
                            <p>
                                SIS potrà inoltre recedere in qualsiasi momento dal Contratto per giusta causa – ovvero, a mero
                                titolo esemplificativo, nell’ipotesi di gravi violazioni del presente Contratto – con l’invio di
                                apposita comunicazione al Cliente a mezzo di e-mail oppure attraverso SMS al recapito telefonico
                                indicato dal Cliente, fermo restando che il recesso così esercitato avrà efficacia al momento del
                                ricevimento della predetta comunicazione da parte del Cliente, salvo in ogni caso il pagamento del
                                Corrispettivo relativo alla eventuale fruizione del Servizio ad opera del Cliente fino alla data
                                di recesso.
                            </p>
                        </div>
                        <div>
                            <h1>Articolo 4 – Utilizzazione del Servizio</h1>
                        </div>
                        <div>
                            <h1>4.1 – Creazione del Profilo Utente </h1>
                            <p>
                                Per essere in grado di utilizzare il Servizio il Cliente deve creare un proprio Profilo Utente
                                all’interno dell’Applicazione che sarà disponibile gratuitamente sui sistemi di distribuzione
                                digitale Google Play © e App Store ©.
                            </p>
                            <p>
                                Ai fini della creazione del proprio Profilo Utente il Cliente dovrà indicare il proprio nome e
                                cognome nonché il proprio numero di telefono e, facoltativamente, indirizzo di posta elettronica
                                che saranno oggetto di idonea verifica attraverso l’invio al recapito telefonico del Cliente di
                                una password temporanea (OTP) da inserire nell’Applicazione per l’autenticazione.
                            </p>
                            <p>
                                Il Cliente potrà procedere alla creazione del proprio Profilo Utente anche tramite meccanismi di
                                Single Sign-On, utilizzando direttamente il proprio account Apple o Google procedendo direttamente
                                all’inserimento delle proprie credenziali.
                            </p>
                            <p>
                                Una volta completata la registrazione, il Cliente riceverà un messaggio e-mail o SMS, a seconda
                                della modalità di creazione del Profilo Utente utilizzata, relativo alla conferma dell’avvenuta
                                registrazione, contenente un collegamento ipertestuale al testo delle Condizioni Generali e alla
                                politica di Privacy allo stesso applicabili.
                            </p>
                            <p>
                                In fase di creazione o aggiornamento del Profilo Utente sarà lasciata al Cliente la possibilità di
                                attivare servizi di geolocalizzazione, al fine di migliorare l’esperienza di utilizzo del
                                Servizio.
                            </p>
                            <p>
                                Una volta creato il proprio Profilo Utente, per autenticarsi in occasione dei successivi accessi
                                all’Applicazione, il Cliente avrà la possibilità, alternativamente, di creare una password tramite
                                un’apposita sezione dell’Applicazione ovvero di continuare ad autenticarsi con codici OTP come
                                avvenuto al momento della creazione del Profilo Utente, fatto salvo il caso in cui il Cliente
                                utilizzi il meccanismo di Single Sign-On, nel qual caso dovrà sempre inserire la password del
                                proprio account Apple o Google.
                            </p>
                            <p>Il Profilo Utente conterrà, inter alia, le seguenti funzioni:</p>
                            <ul>
                                <li>
                                    <p>
                                        la gestione account, che consente all’utente di modificare i dati inseriti in sede di
                                        registrazione;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        la gestione dei consensi marketing, in modo da consentire al Cliente di gestire le proprie
                                        preferenze in relazione ai consensi al trattamento di dati personali;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        le Informazioni legali, ove sarà riportato il Contratto e la privacy policy di volta in
                                        volta in vigore;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        le preferenze cookie, che consentiranno all’utente di esprimere le proprie preferenze
                                        circa l’impiego dei cookie;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        lo storico soste, in modo da permettere all’utente di visionare tutte le comunicazioni
                                        relative ai Servizi e lo storico dei Servizi usufruiti.
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h1>4.2 – Identificazione dell’area di sosta desiderata ad opera del Cliente</h1>
                            <p>
                                Una volta avuto accesso al Servizio, al Cliente sarà messo a disposizione un sistema di
                                navigazione, basato su sistemi forniti da terze parti, attraverso il quale il Cliente potrà
                                identificare le aree di sosta, strutture e zone gestite dai Concessionari.
                            </p>
                            <p>
                                Il Cliente dovrà inserire nell’apposita funzione dell’Applicazione la targa del veicolo ovvero dei
                                veicoli che saranno dallo stesso utilizzati per usufruire del Servizio.
                            </p>
                            <p>
                                Il Cliente dovrà inserire la targa dello specifico veicolo in quel momento utilizzato,
                                nell’apposita funzione dell’Applicazione, la quale opererà un controllo per verificare se il
                                veicolo benefici di condizioni tariffarie agevolate in ragione di eventuali accordi in corso tra
                                SIS ed il Cliente ovvero se allo stesso saranno applicate le condizioni standard relative a
                                ciascuna specifica area di sosta.
                            </p>
                            <p>
                                Attivando l’apposita funzione di geolocalizzazione ovvero operando manualmente la scelta dell’area
                                di sosta desiderata, il Cliente sarà in grado di identificare l’area di sosta gestita dai
                                Concessionari a lui più prossima.
                            </p>
                            <p>
                                Una volta identificata l’area di sosta desiderata, il Cliente dovrà verificare che il codice
                                identificativo delle condizioni tariffarie indicate nella mappa fornita dall’Applicazione coincida
                                con il codice identificativo dell’area di riferimento presente sul singolo parcometro oppure sulla
                                specifica segnaletica che contengono le condizioni orarie e tariffarie della zona di sosta
                                selezionata applicate dal Concessionario nonché, in caso di riduzione, la eventuale percentuale di
                                detta tariffa che sarà addebitata al Cliente a titolo di corrispettivo per l’uso del Servizio (le
                                “<b>Condizioni di Dettaglio Applicabili</b>”).
                            </p>
                            <p>La consultazione delle Condizioni di Dettaglio Applicabili da parte del Cliente è facoltativa.</p>
                            <p>
                                Il Cliente dovrà quindi inserire e verificare, all’interno dell’apposita area dell’Applicazione, i
                                seguenti dati, al fine di conoscere il prezzo totale e le ulteriori condizioni particolari della
                                sosta dallo stesso programmata (le “<b>Condizioni della Sosta</b>”), che verranno espressamente
                                riproposte al Cliente ai fini della accettazione finale delle stesse ad opera del Cliente:
                            </p>
                            <ul>
                                <li>
                                    <p>targa del veicolo;</p>
                                </li>
                                <li>
                                    <p>codice area;</p>
                                </li>
                                <li>
                                    <p>
                                        tipo di tariffazione applicabile (quale a titolo esemplificativo, standard ovvero
                                        residenziale ovvero ancora relativa ad altra categoria, qualora il veicolo goda di detti
                                        benefici);
                                    </p>
                                </li>
                                <li>
                                    <p>durata desiderata della sosta</p>
                                </li>
                                <li>
                                    <p>commissioni</p>
                                </li>
                                <li>
                                    <p>IVA.</p>
                                </li>
                            </ul>
                            <p>
                                Nell’ipotesi di soste del veicolo del Cliente di durata non breve che implichino l’applicazione di
                                tariffe diverse in funzione del giorno e dell’ora di effettiva permanenza in sosta, l’Applicazione
                                provvederà in automatico ad applicare nelle Condizioni della Sosta le condizioni tariffarie più
                                vantaggiose per il Cliente, sulla base dei dati in ordine ai titoli posseduti dal Cliente che
                                saranno stati dallo stesso inseriti nel sistema dell’Applicazione e che lo stesso dichiara sin
                                d’ora essere veritieri e corretti.
                            </p>
                        </div>
                        <div>
                            <h1>
                                Articolo 5 – Corrispettivo del Servizio – Pagamento della sosta - Fornitore dei Servizi di
                                Pagamento – Rendiconto del pagamento effettuato – Creazione del Wallet
                            </h1>
                        </div>
                        <div>
                            <h1>5.1 – Corrispettivo per il Servizio</h1>
                            <p>
                                Il corrispettivo per l’accesso e l’utilizzo del Servizio (il “<b>Corrispettivo</b>”) comprende le
                                tariffe per la sosta applicate da ciascun Concessionario nonché una commissione sulle stesse, che
                                potrà essere rappresentata da un importo fisso ovvero da un importo variabile sino ad un massimo
                                del 20% (venti percento) della relativa tariffa per la sosta applicabile, che sarà espressamente
                                indicata al Cliente nelle Condizioni di Dettaglio Applicabili dell’area di sosta dallo stesso
                                identificata ai sensi del precedente art.4.2.
                            </p>
                            <p>
                                Il Cliente dichiara espressamente di essere a conoscenza che il Corrispettivo dovuto per
                                l’utilizzazione del Servizio non comprende i costi necessari per la connessione all’Applicazione
                                ed ai servizi forniti dal Fornitore dei Servizi di Pagamento ivi compresi, a mero titolo
                                esemplificativo, i costi della connessione alla rete Internet addebitati dal proprio operatore 6
                                telefonico secondo le tariffe dallo stesso applicate al Cliente, che resteranno ad integrale
                                carico del Cliente.
                            </p>
                        </div>
                        <div>
                            <h1>5.2 - Fornitore dei Servizi di Pagamento</h1>
                            <p>
                                Sebbene avvenga attraverso l’apposita funzione presente nell’Applicazione, il pagamento del
                                Servizio da parte del Cliente avrà luogo a mezzo dell’operatore terzo autorizzato a fornire
                                servizi di pagamento elettronico a distanza al pubblico denominato <i>NEXI</i> e della relativa
                                piattaforma di pagamento a distanza (il “<b>Fornitore di Servizi di Pagamento</b>”).
                            </p>
                            <p>
                                Pertanto, tutte le informazioni finanziarie (ad esempio, il numero della carta di credito/debito o
                                la data della scadenza della stessa) inserite dal Cliente nell’Applicazione saranno direttamente
                                ricevute dalla piattaforma elettronica del Fornitore di Servizi di Pagamento, senza che SIS o i
                                Concessionari possano, in alcun modo, avervi accesso.
                            </p>
                        </div>
                        <div>
                            <h1>5.3 – Condizioni di pagamento del Corrispettivo</h1>
                            <p>
                                Il pagamento del Corrispettivo dovuto dal Cliente per la utilizzazione del Servizio potrà essere
                                effettuato soltanto con l’uso delle carte di credito, anche ricaricabili, espressamente indicate
                                dal Fornitore di Servizi di Pagamento e reperibili come indicato nel precedente art. 2.1 lett. d.
                            </p>
                            <p>
                                L’addebito della tariffa relativa ad ogni singola sosta effettuata dal veicolo del Cliente avrà
                                luogo ad opera del Fornitore dei Servizi di Pagamento con le seguenti alternative modalità di
                                tariffazione, a scelta del Cliente:
                            </p>
                            <ol type="i">
                                <li>
                                    <p>
                                        con l’applicazione della tariffa oraria, con addebito del Corrispettivo al termine della
                                        sosta, il cui periodo può essere dal Cliente esteso o concluso in anticipo, salvo il
                                        pagamento del Corrispettivo per il Servizio effettivamente fruito dal Cliente (la “
                                        <b>Tariffa Oraria</b>”);
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        con l’applicazione della tariffa unica, con addebito immediato e con esclusione di ogni
                                        rimborso o possibilità di estendere il periodo di sosta (la “<b>Tariffa Unica</b>”).{' '}
                                    </p>
                                </li>
                            </ol>
                            <p>
                                Qualora al momento dell’addebito al Cliente lo strumento di pagamento indicato dallo stesso
                                dovesse essere non capiente ovvero, per qualunque ragione attribuibile al gestore del conto
                                corrente o alla carta di credito del Cliente, il pagamento non andasse a buon fine, il Servizio
                                cesserà di provvedere al pagamento della tariffa di sosta dovuta dal Cliente, e pertanto il
                                Cliente sarà passibile della relativa contravvenzione, ivi incluso nel caso di addebiti quotidiani
                                di soste a Tariffa Oraria protrattesi oltre il giorno solare in cui i Servizi hanno avuto inizio.
                            </p>
                            <p>
                                Inoltre, nell’ipotesi in cui lo strumento di pagamento indicato dal Cliente dovesse essere non
                                capiente ovvero per qualunque ragione attribuibile al gestore del conto corrente o alla carta di
                                debito o credito del Cliente e il pagamento della sosta non andasse a buon fine, il Servizio sarà
                                automaticamente sospeso sino a che il Cliente avrà saldato il proprio debito.
                            </p>
                            <p>
                                Una volta effettuato il pagamento del servizio di sosta selezionato, il Cliente riceverà un
                                messaggio di notifica “<i>push</i>” sul terminale utilizzato per la conferma dell’ordine e di
                                inizio dell’esecuzione del servizio di sosta.
                            </p>
                            <p>
                                Il Cliente riceverà al termine della sosta, a mezzo di posta elettronica presso l’indirizzo di
                                posta elettronica dallo stesso indicato, una ricevuta non fiscale contenente l’indicazione di
                                quanto versato a titolo di pagamento del Servizio, mentre potrà ottenere anche l’invio di regolare
                                fattura inoltrando apposita richiesta completa dei relativi dati al recapito{' '}
                                <a href="mailto:info@muvin.it">
                                    <i>info@muvin.it</i>
                                </a>
                                .
                            </p>
                            <p>
                                Inoltre, il Cliente sarà in grado di consultare, presso una apposita sezione dell’Applicazione,
                                tutte le transazioni dallo stesso eseguite nel corso della utilizzazione del Servizio.
                            </p>
                        </div>
                        <div>
                            <h1>5.4 Creazione del Wallet</h1>
                            <p>
                                Il pagamento dei Servizi da parte del Cliente potrà avvenire anche attraverso la costituzione di
                                un conto (di seguito, il “
                                <b>
                                    <i>Wallet</i>
                                </b>
                                ”), nel quale il Cliente potrà depositare un <i>plafond</i> di mezzi monetari che potranno essere
                                utilizzati di volta in volta per versare il Corrispettivo dovuto.
                            </p>
                            <p>
                                Il <i>Wallet</i> potrà essere alimentato dal Cliente attraverso un versamento a mezzo di carta di
                                credito sulla piattaforma di pagamento denominata “NEXI”.
                            </p>
                            <p>
                                Le somme contenute nel <i>Wallet</i> decrementeranno esclusivamente a fronte della effettiva
                                fruizione dei Servizi da parte del Cliente e conseguente versamento del relativo Corrispettivo,
                                non essendo previsto alcun corrispettivo o costo per la mera creazione e gestione del{' '}
                                <i>Wallet</i> in assenza di utilizzazione di uno o più Servizi, con la sola eccezione di quanto
                                stabilito nel paragrafo successivo.
                            </p>
                            <p>
                                Il Cliente potrà chiedere il rimborso delle somme versate nel <i>Wallet</i>, anche in tutte le
                                ipotesi di recesso ad opera delle Parti previste dal presente Contratto, fermo restando che SIS
                                tratterrà dalle somme presenti al momento del rimborso un ammontare pari a € 5,00 (Euro cinque/00)
                                Euro a titolo di rimborso dei costi di gestione e chiusura del <i>Wallet</i>, ad esclusione
                                soltanto dell’ipotesi del recesso del Cliente entro il Periodo di Legge di cui al precedente art.
                                5.1.
                            </p>
                        </div>
                        <div>
                            <h1>Articolo 6 – Responsabilità</h1>
                        </div>
                        <div>
                            <h1>6.1 – Responsabilità del Cliente</h1>
                            <p>
                                Il Cliente è responsabile della conservazione e dell’utilizzazione dei codici di sicurezza
                                (credenziali di accesso e <i>password</i>) che gli consentono di accedere al Servizio a mezzo del
                                proprio Profilo Utente. Il Cliente è pertanto tenuto a adottare ogni misura necessaria a mantenere
                                la più stretta riservatezza in ordine a detti codici ed a non comunicarli a terzi, ivi compreso ad
                                una persona vicina o ad un membro della propria famiglia, e a non conservarli per iscritto.{' '}
                            </p>
                            <p>
                                Il Cliente si impegna a fornire informazioni veritiere e a non occultare la propria identità e/o
                                non fornire un’identità falsa.
                            </p>
                            <p>
                                SIS si riserva il diritto di chiudere o sospendere il Profilo Utente qualora lo stesso dovesse
                                contenere informazioni non corrette o false.
                            </p>
                            <p>
                                Anche successivamente alla registrazione, il Cliente è obbligato a verificare che i dati
                                registrati rimangano aggiornati e corretti. SIS declina ogni responsabilità relativa ad errori od
                                omissioni del Cliente in fase di attivazione ovvero di successiva manutenzione del proprio Profilo
                                Utente.
                            </p>
                            <p>
                                Il Cliente resta in ogni caso responsabile della consultazione e della eventuale violazione della
                                segnaletica apposta presso le aree di sosta dallo stesso scelte, nonché delle normative emanate
                                dalle competenti Autorità o dagli Enti titolari o gestori delle aree di sosta.
                            </p>
                        </div>
                        <div>
                            <h1>6.2 – Responsabilità di SIS</h1>
                            <p>
                                SIS non potrà essere ritenuta responsabile delle conseguenze derivanti dalla eventuale
                                utilizzazione fraudolenta da parte di terzi dei codici di accesso al Profilo Utente del Cliente.
                            </p>
                            <p>
                                SIS non potrà altresì essere ritenuta responsabile dei danni, di natura materiale o immateriale,
                                provocati dalla illecita intrusione informatica, <i>cyber</i> attacco o contaminazione di virus
                                del telefono cellulare o del <i>tablet</i> utilizzati dal Cliente per accedere al Servizio, che
                                abbiano come causa, origine o fondamento l’utilizzazione del Servizio da parte del Cliente e che
                                non siano stati causati da SIS o dalle società che forniscono alla stessa servizi relativi al
                                Servizio.
                            </p>
                            <p>
                                Parimenti SIS non potrà essere ritenuta responsabile di qualunque malfunzionamento o interruzione
                                relativa (i) alla rete Internet, (ii) a restrizioni all’accesso alla rete Internet nonché (iii) a
                                qualunque malfunzionamento del telefono cellulare o del tablet del Cliente, che impediscano e/o
                                interferiscano negativamente sull’accesso al Servizio e sulla regolare utilizzazione dello stesso
                                da parte del Cliente.
                            </p>
                            <p>
                                Il Cliente riconosce che SIS non potrà essere ritenuta responsabile a causa dell’interruzione
                                dell’accesso al Servizio che sia dovuta a necessari o opportuni interventi di manutenzione dello
                                stesso posti in essere da SIS ovvero dal Fornitore dei Servizi di Pagamento ovvero che sia dovuta
                                a cause di forza maggiore.
                            </p>
                        </div>
                        <div>
                            <h1>Articolo 7 – Cessazione del Servizio - Risoluzione del Contratto</h1>
                            <p>
                                <b>7.1</b> L’accesso al Servizio avrà termine a seguito del recesso dal Contratto ad opera del
                                Cliente ovvero ad opera di SIS ai sensi e nelle forme di cui agli artt.3 ed 11.
                            </p>
                            <p>
                                <b>7.2</b> Il Contratto sarà considerato risolto di diritto ai sensi e per gli effetti di cui
                                all’art.1456 del Codice Civile in caso di:
                            </p>
                            <ol type="i">
                                <li>
                                    <p>
                                        comunicazione di dati falsi da parte del Cliente nella creazione o manutenzione del
                                        proprio Profilo Utente;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        mancato versamento da parte del Cliente del Corrispettivo per il Servizio per un periodo
                                        temporale pari a 90 (novanta) giorni;
                                    </p>
                                </li>
                                <li>
                                    <p> illegittima o fraudolenta utilizzazione del Servizio da parte del Cliente.</p>
                                </li>
                            </ol>
                        </div>
                        <div>
                            <h1>Articolo 8 – Cessione del Contratto – Reclami - Mediazione</h1>
                            <p>
                                <b>8.1</b> Anche ai sensi e per gli effetti di cui all'art. 1407 c.c., SIS potrà cedere il
                                Contratto, o i diritti dallo stesso derivanti, a società controllate, collegate o sotto il comune
                                controllo della stessa, in qualsiasi momento e senza necessità di alcuna accettazione da parte del
                                Cliente, dando informazione al Cliente dell'avvenuta cessione per mezzo di comunicazione via
                                e-mail oppure attraverso SMS al recapito telefonico indicato dal Cliente, fermo restando tuttavia
                                che in tal caso SIS rimarrà in ogni caso garante nei confronti del Cliente dell’adempimento del
                                Contratto.
                            </p>
                            <p>
                                Il Cliente non potrà cedere il Contratto a terzi se non previa accettazione scritta da parte di
                                SIS.
                            </p>
                            <p>
                                <b>8.2</b> Per qualunque richiesta di informazioni relativa al Contratto o al Servizio il Cliente
                                potrà scrivere a SIS a mezzo di posta elettronica presso il seguente indirizzo:{' '}
                                <a href="mailto:info@muvin.it">
                                    <i>info@muvin.it</i>
                                </a>
                                .
                            </p>
                            <p>
                                Qualora le risposte ottenute dal Cliente dal predetto servizio di informazioni non fossero
                                ritenute soddisfacenti, il Cliente potrà formulare un reclamo a SIS che dovrà essere indirizzato
                                al Dipartimento Rapporti con il consumatore presso il seguente recapito:{' '}
                                <a href="mailto:reclami@sis.city">
                                    <i>reclami@sis.city.</i>
                                </a>
                            </p>
                            <p>
                                <b>8.3</b> Nel caso di controversie aventi ad oggetto i Servizi tra SIS ed un Cliente che sia “
                                <i>Consumatore</i>” ovvero agisca per scopi estranei all’attività imprenditoriale, commerciale,
                                artigianale o professionale svolta dallo stesso ai sensi dell’art.18 del Codice del Consumo, si
                                assicura sin d'ora la partecipazione di SIS ad un tentativo di conciliazione amichevole che il
                                Cliente potrà promuovere davanti a <i>RisolviOnline</i>, un servizio indipendente e istituzionale
                                fornito dalla Camera Arbitrale della Camera di Commercio di Milano, che consente di raggiungere un
                                accordo soddisfacente, con l'aiuto di un conciliatore neutrale e competente, in un modo amichevole
                                e sicuro su Internet ovvero presso ogni altro organismo di risoluzione delle controversie scelto
                                dal Cliente.
                            </p>
                            <p>
                                Per maggiori informazioni sul regolamento di RisolviOnline o per inviare una richiesta di
                                conciliazione accedi a{' '}
                                <a href="https://www.risolvionline.com">
                                    <i>www.risolvionline.com</i>
                                </a>
                                .
                            </p>
                        </div>
                        <div>
                            <h1>Articolo 9 – Trattamento dei dati personali </h1>
                            <p>
                                <b>9.1</b> La società S.I.S. Segnaletica Industriale Stradale S.r.l. nella sua qualità di Titolare
                                del trattamento (nel seguito anche, il “<b>Titolare</b>”) tratta i dati personali acquisiti
                                nell’esecuzione o in dipendenza del presente Contratto nel rispetto delle disposizioni del
                                Regolamento Generale sulla protezione dei dati n. 2016/679, di ogni legge e provvedimento in
                                materia di protezione dei dati personali di volta in volta applicabile e secondo le modalità
                                previste dall’informativa privacy disponibile nell’apposita sezione dell’Applicazione resa dal
                                Titolare e visionata dal Cliente al momento di registrazione all’Applicazione.
                            </p>
                        </div>
                        <div>
                            <h1>Articolo 10 - Proprietà industriale ed intellettuale</h1>
                            <p>
                                Tutti i diritti di utilizzazione economica (ivi compresi, a mero titolo esemplificativo, quelli
                                relativi a programmi informatici, codici sorgente e algoritmi) relativi al Servizio,
                                all’Applicazione e ai relativi contenuti e funzionalità, sono di titolarità di, ovvero concessi in
                                licenza a, SIS, suoi fornitori e partner.
                            </p>
                            <p>
                                Tali diritti non sono in alcun modo da considerarsi concessi in licenza o trasferiti a qualsiasi
                                titolo al Cliente in ragione della utilizzazione del Servizio/dell’Applicazione da parte dello
                                stesso, il quale non ha diritto di utilizzarli se non in stretta conformità a quanto necessario ai
                                fini dell’utilizzazione del Servizio.
                            </p>
                            <p>
                                Al Cliente è fatto espresso divieto di copiare, distribuire, vendere, pubblicare, trasferire, dare
                                in prestito, concedere in licenza, modificare o disporre in qualunque altro modo del software
                                relativo al Servizio e/o all’Applicazione.
                            </p>
                            <p>
                                Tutti i diritti relativi gli elementi audiovisivi dell’Applicazione, nonché disegni, loghi,
                                intestazioni, icone, script, denominazioni del Servizio, compresa la tecnologia su cui si basa il
                                Servizio, sono di titolarità esclusiva di SIS e sono protetti a norma di legge.
                            </p>
                        </div>
                        <div>
                            <h1>Articolo 11 – Modifica del Contratto – Ulteriore diritto di recesso del Cliente</h1>
                            <p>
                                Nell’ipotesi in cui SIS avesse necessità di modificare le condizioni di cui a questo Contratto in
                                corso di esecuzione dello stesso, al Cliente verrà espressamente richiesto di accettare le nuove
                                condizioni generali del Servizio tramite un apposito comando che sarà mostrato al momento del
                                primo accesso successivo all’entrata in vigore di dette nuove condizioni generali.
                            </p>
                            <p>
                                Qualora il Cliente non accetti le nuove Condizioni Generali, egli non avrà la possibilità di
                                proseguire ad utilizzare l’Applicazione ai fini della fruizione del Servizio e il Profilo Utente
                                dello stesso verrà immediatamente cancellato.
                            </p>
                            <p>
                                Qualora invece il Cliente accetti nelle forme sopra indicate le nuove Condizioni Generali, allo
                                stesso sarà consentito di proseguire nella utilizzazione dell’Applicazione e riceverà a tal fine
                                una comunicazione SMS/e-mail di conferma dell’adesione alle nuove Condizioni Generali contenente
                                il collegamento ipertestuale alle stesse.
                            </p>
                        </div>
                        <div>
                            <h1>Articolo 12 – Legge applicabile – Foro competente esclusivo – Versione linguistica</h1>
                            <p>
                                <b>12.1</b> Questo Contratto è regolato dalla legge italiana.
                            </p>
                            <p>
                                <b>12.2</b> Per decidere di qualsiasi controversia che dovesse sorgere in merito
                                all'interpretazione, esecuzione o risoluzione del presente Contratto, sarà competente in via
                                esclusiva la giurisdizione italiana e l’Autorità Giudiziaria determinata come segue:
                            </p>
                            <ol type="i">
                                <li>
                                    <p>
                                        nell’ipotesi il cui il Cliente sia un “Consumatore” ovvero agisca per scopi estranei
                                        all’attività imprenditoriale, commerciale, artigianale o professionale svolta dallo stesso
                                        ai sensi dell’art.18 del Codice del Consumo: l’Autorità Giudiziaria del luogo di residenza
                                        o domicilio del Cliente;
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        nell’ipotesi in cui il Cliente sia un “Professionista” ovvero agisca per scopi nell’ambito
                                        all’attività imprenditoriale, commerciale, artigianale o professionale svolta dallo stesso
                                        ai sensi dell’art.18 del Codice del Consumo: l’Autorità Giudiziaria di Perugia (Italia).
                                    </p>
                                </li>
                            </ol>
                            <p>
                                <b>12.3</b> L’invalidità, nullità o inefficacia di una qualsiasi disposizione del presente
                                Contratto non avranno alcun effetto sulla validità ed efficacia delle altre clausole del
                                Contratto.
                            </p>
                            <p>
                                <b>12.4</b> Il presente Contratto è reso disponibile da SIS anche in lingua inglese, fermo
                                restando che in caso di difformità tra la versione in lingua inglese e quella in lingua italiana
                                quest’ultima prevarrà ad ogni effetto.
                            </p>
                        </div>
                    </div>
                </div>
                <footer className={classes.footer}>
                    <img src="/assets/images/logo_muvin_color.png" alt="logo muvin" className={classes.logo} />
                    muvin
                    <img src="/assets/svg/logo_sis.svg" alt="logo muvin" className={classes.logo} />
                </footer>
            </main>
        </div>
    );
};

export default TermsAndConditions;

